// NotificationModal.js
import React from 'react';
import Modal from 'olive-react-myoneui/lib/Modal';
import Button from 'olive-react-myoneui/lib/Button';
import { logout } from '../../../utils/auth';

const EmailUpdateModal = ({title, message}) => {
  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    const hostname = window.location.hostname;
    const url = `https://${hostname}/login`;
    window.location.replace(url);
  }

  return (
    <Modal centered show={true} contentClassName={'p-4'}>
        <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body><p>{message}</p></Modal.Body>
        <Modal.Footer>
          <Button variant={"orange"} onClick={handleLogout}>
             {'Required to Re-login'}
          </Button>
        </Modal.Footer>
    </Modal>
  );
}

export default EmailUpdateModal;
